import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import ItemCard from './ItemCard'
import entityHelper from '../../utils/entityHelper'

const { getUnitData } = entityHelper

const UnitDisplay = (props) => {
    const {
        baseUnit, equipment, showEquipment, showStats, handleEquip, handleUnequip,
    } = props
    const {
        name, avatar, race, stats, status,
    } = getUnitData(baseUnit)

    const dataBox = (data) => {
        if (typeof data === 'undefined' || showStats !== true) { return '' }
        const attributes = Object.keys(data).map(attribute => (
            <tr key={attribute}>
                <td>{attribute}</td>
                <td>{stats[attribute]}</td>
            </tr>
        ))

        return (<table><tbody>{attributes}</tbody></table>)
    }

    const inventoryBox = () => {
        if (typeof equipment === 'undefined' || showEquipment !== true) { return '' }

        return (
            <div className="equipment__monitor">
                <h2>Equipped</h2>
                <div className="equipment__monitor--listing">
                    {equipment.map(item => (
                        <ItemCard
                            key={item.ID}
                            item={item}
                            clickEquip={handleEquip}
                            clickUnequip={handleUnequip}
                        />
                    ))}
                </div>
            </div>
        )
    }

    return (
        <Fragment>
            <h1>
                {`Unit: ${name}`}
            </h1>
            <div className="unit__monitor--member">
                <div className="unit__monitor--img">
                    {avatar}
                </div>
                <div className="unit__monitor--detail">
                    <div className="unit__monitor--name">
                        {`${name} (${race})`}
                    </div>
                    <div className="unit__monitor--stats">
                        {dataBox(stats)}
                    </div>
                </div>
            </div>

            {dataBox(status)}
            {inventoryBox(equipment)}

        </Fragment>
    )
}

UnitDisplay.propTypes = {
    baseUnit: PropTypes.object.isRequired,
    equipment: PropTypes.array.isRequired,
    showEquipment: PropTypes.bool.isRequired,
    showStats: PropTypes.bool.isRequired,
    handleEquip: PropTypes.object.isRequired,
    handleUnequip: PropTypes.object.isRequired,
}

export default UnitDisplay
